import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgNaamplaatjeAanvragen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      d="M35 11H5v18h30z"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M34 11H5v18h30V11zm0 17H6V12h28z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M30 17.5H10v1h20zM20 21.5H10v1h10z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgNaamplaatjeAanvragen);

export default ForwardRef;
